import { memo, useCallback } from 'react';

import { useI18n } from '@affine/i18n';

import { IconButton } from '../../../button';
import { formatPickerAccessibleName } from '../accessible-name';

// Memoized individual emoji button to prevent unnecessary re-renders
export const EmojiButton = memo(function EmojiButton({
  emoji,
  onSelect,
}: {
  emoji: string;
  onSelect: (emoji: string) => void;
}) {
  const t = useI18n();
  const handleClick = useCallback(() => {
    onSelect(emoji);
  }, [emoji, onSelect]);

  return (
    <IconButton
      key={emoji}
      size={24}
      style={{ padding: 4 }}
      icon={<span>{emoji}</span>}
      iconStyle={{ justifyContent: 'center' }}
      aria-label={formatPickerAccessibleName(
        t['com.affine.icon-picker.select-emoji'](),
        emoji
      )}
      tooltip={formatPickerAccessibleName(
        t['com.affine.icon-picker.select-emoji'](),
        emoji
      )}
      onClick={handleClick}
    />
  );
});
